export const hasValidDireccionSelector = (state: $TSMigrationFixMe) => {
  const { empresaActiva } = state.user

  return (
    empresaActiva?.direccion &&
    empresaActiva?.cp &&
    (empresaActiva?.poblacionId || empresaActiva?.poblacionExtranjera)
  )
}

export const getEmpresaActiva = (state: $TSMigrationFixMe) => {
  const { empresaActiva } = state.user

  return empresaActiva
}

export const getCurrencyDocumentActive = (state: $TSMigrationFixMe) => {
  const { currency } = state.documentos

  return currency
}
export const getUser = ({ user }: $TSMigrationFixMe) => user

export const getValidateModalStatusSelector = (state: $TSMigrationFixMe) => {
  const { empresa } = state

  return empresa
}

export const getDepartamentos = (state: $TSMigrationFixMe) => {
  const { departamentos, departamentosTotalCount } = state.user
  return { departamentos, departamentosTotalCount }
}

export const getEmpresaActivaConfigCuentasContables = (
  state: $TSMigrationFixMe
) => {
  const { empresaActiva } = state.user
  return empresaActiva.configuracion?.configuracionCuentasContables || []
}
